import zonesClient from '../../utils/zonesClient';
import {
  IGetInfoQuotasProps,
  IPutQuotasProps,
  IGetMedianZonesProps,
  IPutListProps,
} from './model';

export const getInfoQuotas = async ({
  zone_id,
  quota_type,
  min,
  max,
}: // eslint-disable-next-line consistent-return
IGetInfoQuotasProps) => {
  const path: any = process.env.REACT_APP_ZONES_GET_INFO_QUOTAS;
  if (
    process.env.REACT_APP_ZONES_API_URL &&
    process.env.REACT_APP_ZONES_GET_INFO_QUOTAS &&
    process.env.REACT_APP_ZONES_API_KEY
  ) {
    const { data } = await zonesClient.get(path, {
      params: {
        zone_id,
        quota_type,
        min,
        max,
      },
    });

    return data;
  }
};

export const putQuotas = async ({
  zone_id,
  type_list,
  value,
  min,
  max,
  quota_type,
}: // eslint-disable-next-line consistent-return
IPutQuotasProps = {}) => {
  const pathQuotas: any = process.env.REACT_APP_ZONES_PUT_QUOTAS;
  if (
    process.env.REACT_APP_ZONES_API_URL &&
    process.env.REACT_APP_ZONES_GET_INFO_QUOTAS &&
    process.env.REACT_APP_ZONES_API_KEY
  ) {
    const { data } = await zonesClient.put(pathQuotas, {
      zone_id,
      type_list,
      value,
      quota_type,
      min,
      max,
    });

    return data;
  }
};

export const getMedianZones = async ({
  zone_id,
  lote_name,
  page,
  items,
}: // eslint-disable-next-line consistent-return
IGetMedianZonesProps = {}) => {
  const pathGetMedianZones: any = process.env.REACT_APP_GET_LOTES_MEDIAN_ZONE;
  if (
    process.env.REACT_APP_ZONES_API_URL &&
    process.env.REACT_APP_ZONES_GET_INFO_QUOTAS &&
    process.env.REACT_APP_ZONES_API_KEY
  ) {
    const { data } = await zonesClient.get(pathGetMedianZones, {
      params: {
        zone_id,
        lote_name,
        page,
        items,
      },
    });

    return data;
  }
};

interface IgetListDetail {
  median_zone_id?: number;
  lote_name?: string;
}
export const getListDetail = async ({
  median_zone_id,
  lote_name,
}: // eslint-disable-next-line consistent-return
IgetListDetail = {}) => {
  const pathGetDetailList: any = process.env.REACT_APP_GET_DETAIL_LIST;
  if (
    process.env.REACT_APP_ZONES_API_URL &&
    process.env.REACT_APP_ZONES_GET_INFO_QUOTAS &&
    process.env.REACT_APP_ZONES_API_KEY
  ) {
    const { data } = await zonesClient.get(pathGetDetailList, {
      params: {
        median_zone_id,
        lote_name,
      },
    });

    return data;
  }
};

export const putList = async ({
  zone_id,
  type_list,
  lote_name,
  reason,
  note,
  rotation,
  user_email,
  current_list,
}: // eslint-disable-next-line consistent-return
IPutListProps = {}) => {
  const pathPutList: any = process.env.REACT_APP_PUT_LIST;
  if (
    process.env.REACT_APP_ZONES_API_URL &&
    process.env.REACT_APP_ZONES_GET_INFO_QUOTAS &&
    process.env.REACT_APP_ZONES_API_KEY
  ) {
    const { data } = await zonesClient.put(pathPutList, {
      zone_id,
      type_list,
      lote_name,
      reason,
      note,
      rotation,
      user_email,
      current_list,
    });

    return data;
  }
};

export const patchList = async ({
  zone_id,
  lote_name,
  rotation,
}: // eslint-disable-next-line consistent-return
IPutListProps = {}) => {
  const pathPutList: any = process.env.REACT_APP_PUT_LIST;
  if (
    process.env.REACT_APP_ZONES_API_URL &&
    process.env.REACT_APP_ZONES_GET_INFO_QUOTAS &&
    process.env.REACT_APP_ZONES_API_KEY
  ) {
    const { data } = await zonesClient.patch(pathPutList, {
      zone_id,
      lote_name,
      rotation,
    });

    return data;
  }
};
